import React, { useEffect, useState } from "react";
import { Offcanvas, Badge, Card, Row, Col, ProgressBar, Table, Form } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { eiwrsRandomizationSchemaServices } from "../../../APIServices/EIWRS/eiwrsRandomizationSchemaServices";
import Pagination from "../../Pagination";
import { useParams } from "react-router";
import { eiwrsKitMetadataServices } from "../../../APIServices/EIWRS/KitManagement/eiwrsKitMetadataServices";
import { studyTreatmentManagementServices } from "../../../APIServices/CTMS/studyTreatmentManagementServices";

const SubjectDetail = ({ Show, Hide, Title, randomizationType, subjectData, subjectColumns, loading, tableRef, onMouseDown, screenType }) => {
  const [dispenseKit, setDispenseKit] = useState([]);
  const [treatmentColumns, setTreatmentColumns] = useState([]);
  const [dispenseKitCount, setDispenseKitCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const { studyId } = useParams()
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [columns, setColumns] = useState([]);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(dispenseKitCount / itemsPerPage);
  const getAssignedStudySubjectRandomizationKit = async () => {
    setLoader(true)
    let data = await eiwrsRandomizationSchemaServices.getAssignedStudySubjectRandomizationKit(studyId, subjectData?.siteId, subjectData?.subjectId, StudyMode, "", pageNumber, itemsPerPage)
    setDispenseKit(data?.data || [])
    setDispenseKitCount(data?.count || 0)
    setLoader(false)
  }

  const getEIWRSKitMetadataData = async (e) => {
    let data = await eiwrsKitMetadataServices.getEIWRSKitMetadataData(
      "active",
      studyId,
    );
    setColumns(data?.data || []);
  };

  const getStudyTreatmentColumnData = async (e) => {
    let data = await studyTreatmentManagementServices.getStudyTreatmentColumnData(
      "active",
      studyId
    );
    setTreatmentColumns(data?.data || []);
  };

  useEffect(() => {
    getEIWRSKitMetadataData();
    getStudyTreatmentColumnData();
  }, []);

  useEffect(() => {
    if (randomizationType != "assignBased" && subjectData?.siteId && subjectData?.schemaId && subjectData?.subjectId) {
      getAssignedStudySubjectRandomizationKit();
    }
  }, [randomizationType, Show, subjectData?.siteId, subjectData?.schemaId, subjectData?.subjectId]);
  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" size="lg" style={{ width: 850 }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {/* Subject Header */}
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h5 style={{ fontSize: 14 }} className="mb-1">{subjectData?.row?.SCREENID}</h5>
          </div>
          {screenType === "eiwrs" &&
            <Badge
              bg={subjectData?.screenStatus === "Pending" ? "secondary-subtle" : subjectData?.screenStatus === "Failed" ? "danger-subtle" : "success-subtle"}
              style={{ fontSize: 10 }}
              className={`br3 ${subjectData?.screenStatus === "Pending" ? "text-secondary border-secondary" : subjectData?.screenStatus === "Failed" ? "text-danger border-danger" : "text-success border-success"} border px-2 text-capitalize mx-2`}
            >
              {subjectData?.screenStatus}
            </Badge>
          }
        </div>

        {/* Subject Details */}
        {loading ?
          <div><PageLoader /></div>
          :
          <Card className="mb-3">
            <Card.Body className="p-3">
              <Row>
                {subjectColumns?.map((item, index) => (
                  <Col className="mb-2" key={index} xs={3}>
                    <div className="text-muted small">{item?.columnLabel}</div>
                    <small style={{ fontSize: 12 }}>{subjectData?.row?.[item?.columnName] || "_"}</small>
                  </Col>
                ))}
              </Row>
            </Card.Body>
          </Card>
        }
        {randomizationType !== "assignBased" &&
          <>
            {loader ?
              <div><PageLoader /></div>
              : dispenseKitCount === 0 ? (
                <div className={`hstack justify-content-center align-items-center`}>
                  <Form.Label className="fw-bold p-2 text-center">Study Kit not found!</Form.Label>
                </div>
              )
                :
                <>
                  <Table ref={tableRef} className="m-0 custom-table" hover striped>
                    <thead className="position-sticky top-0 z-1">
                      <tr>
                        <th
                          onMouseDown={(e) => onMouseDown(e, 0)}
                          style={{ width: 45 }}
                          className="text-center"
                        >
                          Sr.
                        </th>
                        <th onMouseDown={(e) => onMouseDown(e, 1)}>
                          SiteId
                        </th>
                        <th onMouseDown={(e) => onMouseDown(e, 2)}>
                          SubjectId
                        </th>
                        <th onMouseDown={(e) => onMouseDown(e, 3)}>
                          EventId
                        </th>
                        <th onMouseDown={(e) => onMouseDown(e, 4)}>
                          Time Point Id
                        </th>
                        <th onMouseDown={(e) => onMouseDown(e, 5)}>
                          Kit Number
                        </th>
                        {columns?.filter(column => column?.isUnique === "yes")?.map((item, index) => (
                          <th onMouseDown={(e) => onMouseDown(e, 5 + index)}>
                            {item?.columnLabel}
                          </th>
                        ))}
                        {treatmentColumns?.map((item, index) => (
                          <th onMouseDown={(e) => onMouseDown(e, columns?.length + 5 + index)}>
                            {item?.columnLabel}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {dispenseKit?.map((kitData, index) => (
                        <tr
                          key={index}
                          title="View Details"
                        >
                          <td
                            className="text-center"
                          >
                            {index + 1 + startIndex}.
                          </td>
                          <td>{kitData?.siteName}</td>
                          <td>{kitData?.subjectName}</td>
                          <td>{kitData?.eventName}</td>
                          <td>{kitData?.timePointId || "_"}</td>
                          <td>{kitData?.kitNumber}</td>
                          {columns?.filter(column => column?.isUnique === "yes")?.map(item => {
                            const columnData = (kitData?.columns || [])?.find(
                              (ele) => ele?.columnName === item?.columnName
                            );
                            return (
                              <td
                                key={item?.columnId || item?.columnName}
                              >
                                {columnData?.columnValue || ""}
                              </td>
                            );
                          })}
                          {treatmentColumns?.map(item => {
                            return (
                              <td
                                key={item?.columnId || item?.columnName}
                              >
                                {kitData?.treatmentData[item?.columnName] || ""}
                              </td>
                            );
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <div className="position-sticky bottom-0 start-0">
                    <Pagination
                      totalPage={totalPage}
                      pageNumber={pageNumber}
                      itemsPerPage={itemsPerPage}
                      totalItems={setDispenseKitCount}
                      setPageNumber={setPageNumber}
                      setItemsPerPage={setItemsPerPage}
                    />
                  </div>
                </>
            }
          </>
        }
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default SubjectDetail;